module.exports = __webpack_public_path__ + "img/84_18.6654835c.png";